//Built-In
import React, { Fragment } from 'react';

//External
import { Card, Col, Row } from "react-bootstrap";
import Select from "react-select";
import cx from "classnames";
import parseHtml from 'html-react-parser';
import {getRefVariableFields, getSessionValue, getWABodyVariables, isMobile, replaceStringTohtml} from "../../Common/Appcommon";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircleInfo} from "@fortawesome/free-solid-svg-icons/faCircleInfo";
import CratioTooltip from "../../Common/CratioTooltip";
import { Controller } from "react-hook-form";
//Internal
import './BodyComponent.css';


export default class BodyComponent extends React.Component{
    formname = getSessionValue('leadformname');
    constructor(props) {
        super(props);
        this.state = {
            refformfields: {}
        }
    }
    componentDidMount() {
        getRefVariableFields().then((response) => {
            this.setState({ refformfields: response });
        });
    }
    getVariableContent = (selectId, fieldsOptions) => {
        let selectedValue = this.props.values[selectId + "_selected"];
        if (selectedValue !== undefined && selectedValue.value === undefined) {
            selectedValue = '';
        }
        return (
            <Select
                id={selectId}
                name={selectId}
                value={selectedValue !== undefined ? selectedValue : ""}
                onChange={(e) => {
                    this.props.handleChange(e, selectId)
                }}
                menuPlacement={"auto"}
                menuPosition={'fixed'}
                options={fieldsOptions}
                className={`basic-multi-select `}
                classNamePrefix="wa-select"
                required={true}
            />
        )
    }

    getHookFormVariableContent = (selectId, fieldsOptions) => {
        let selectedValue = this.props.values[selectId + "_selected"];
        if (selectedValue !== undefined && selectedValue.value === undefined) {
            selectedValue = '';
        }
        const { register, control, formState: { errors } } = this.props.useForm;
        const controller = this.props.controller;
        return (
            <>
                <Controller
                    name={selectId}
                    control={control}
                    rules={
                        {
                            required: selectedValue === undefined ||
                                selectedValue.value == undefined ?
                                "Message variable not selected" : false
                        }
                    }
                    render={({ field }) => {
                        return (
                            <Select
                                {...field}
                                id={selectId}
                                name={selectId}
                                value={selectedValue !== undefined ? selectedValue : ""}
                                onChange={(e) => {
                                    this.props.handleChange(e, selectId)
                                    field.onChange(e);
                                }}
                                menuPlacement={"auto"}
                                menuPosition={'fixed'}
                                options={fieldsOptions}
                                className={`basic-multi-select ${errors[selectId] ? 'is-invalid' : ''}`}
                                classNamePrefix="wa-select"
                                required={selectedValue == ''}
                            />
                        );
                    }}
                />
                {errors[selectId] && <em className={`error invalid-feedback`}>{errors[selectId].message}</em>}
            </>
        )
    }

    render() {
        let { component, formDetail, source, values } = this.props;
        let { refformfields } = this.state;
        let formInfo = formDetail !== undefined && formDetail[0] !== undefined ? formDetail[0] : [];
        let fieldDetails = formDetail !== undefined && formDetail[1] !== undefined ? formDetail[1] : [];
        let bodyText = '';
        let variables = [];
        if (source === 'quickreply' || source === 'auto-reply') {
            bodyText = values['Message'] !== undefined ? values['Message'] : '';
            variables = getWABodyVariables(bodyText);
        } else {
            // Carousel cards synced from Meta may omit 'text' on the BODY component.
            bodyText = component !== undefined && component['text'] !== undefined ? component['text'] : '';
            variables = getWABodyVariables(bodyText);
        }
        // Check before converting to html: replaceStringTohtml turns spaces into &nbsp;.
        let hasBodyText = String(bodyText).trim() !== '';
        bodyText = replaceStringTohtml(bodyText);
        // for order by variable's
        variables = variables.sort((a, b) => a - b);

        let fieldsOptions = [];
        let entityGroupFields = [];
        let skipFields = [
            `${this.formname}_id`,
            'Lead_ID',
            'wsapp_recent_activity',
            'wsapp_convo_status',
            'wsapp_unread_count',
            'wsapp_optin_status',
            'wsapp_recent_msg_id',
            'wsapp_enabled',
            'wsapp_blocked',
            'wsapp_opt',
            'wsapp_last_delivered',
            'wsapp_last_read',
            'wsapp_last_replied',
            'wsapp_last_sent_msg_id',
            'wsapp_last_sent_msg_id',
            'wsapp_completed_campaign'
        ];

        fieldsOptions.push({
            value: 'fallback', label: 'Use Fallback', fieldType: 'fallback'
        });
        fieldDetails && fieldDetails.map((field) => {
            let fieldName = field[2];
            let fieldLabel = field[3];
            let fieldType = field[4];
            let isConfigHide = parseInt(field[10]);
            let isViewHide = parseInt(field[11]);
            let formLabel = formInfo[2] || field[0];
            if (!isConfigHide && !isViewHide) {
                if (fieldType !== 'subtable' && fieldType !== 'reference_entityid' && fieldType !== "reference_group" && fieldType !== "form_history") {
                    if (!skipFields.includes(fieldName)) {
                        if (fieldLabel !== undefined && fieldName !== undefined) {
                            if (fieldType === 'entity_group') {
                                if (Array.isArray(refformfields)) {
                                    refformfields.forEach(refField => {
                                        entityGroupFields.push({
                                            value: refField.value, label: refField.label, fieldType: refField.fieldType
                                        });
                                    });
                                }
                            } else {
                                fieldsOptions.push({
                                    value: fieldName, label: formLabel.toUpperCase() + "::" + fieldLabel, fieldType: fieldType
                                });
                            }
                        }
                    }
                }
            }
        });
        fieldsOptions = fieldsOptions.concat(entityGroupFields);
        return (
            <div className="body-component-wrapper">
                <div className={'d-grid'}>

                    {
                        source !== 'quickreply' && source !== 'auto-reply' && hasBodyText &&
                        (
                            <>
                                <label className={'group-header-lbl'}>Body</label>
                                <div className={'body-content-txt'} style={{ wordWrap: 'break-word', wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                                    <span className="content-preview" style={{ display: 'block', maxWidth: '100%', overflow: 'hidden' }}>
                                        <span className="" dir="auto">
                                            {parseHtml(bodyText)}
                                        </span>
                                    </span>
                                </div>
                            </>
                        )
                    }

                    {
                        source === 'quickreply' && variables !== undefined && variables.length > 0 &&
                        <Row className={'mt-4'}>
                            <Col md={'12'}>
                                <Row>
                                    <Col md={'2'} sm={'3'} xs={'12'}><span className={font-semibold}>Variable</span></Col>
                                    <Col md={'5'} sm={'4'} xs={'12'}><span className={font-semibold}>Value</span></Col>
                                    <Col md={'5'} sm={'5'} xs={'12'}><span className={font-semibold}>Fallback Value {source === 'quickreply' && <CratioTooltip title={"In case the dynamic value is empty for a particular customer, the fallback value will instead be sent."} content={<span><FontAwesomeIcon icon={faCircleInfo}/></span>} />}</span></Col>
                                </Row>
                            </Col>
                        </Row>
                    }

                    {
                        variables.map((variable) => {
                            let prefix = this.props.isCarousel && this.props.cardIndex !== undefined ? `carousel_card_${this.props.cardIndex}_` : '';
                            let divId = prefix + 'body-variable-' + variable;
                            let selectId = prefix + 'body_variable_field_' + variable;
                            let defaultValueID = prefix + 'body_df_value_field_' + variable;

                            return (
                                <Row className={'mt-2 mb-3'} key={variable}>
                                    <Col md={'12'}>
                                        <Row id={divId}>
                                            <Col md={'2'} sm={'3'} xs={'12'} className={cx('',{'pr-0' : !isMobile()})} >
                                                <input
                                                    type={'text'}
                                                    disabled={true}
                                                    className={'form-control text-center'}
                                                    value={'{{ ' + variable + ' }}'}
                                                    style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}
                                                />
                                            </Col>
                                             <Col md={source !== 'quickreply' ? '6' : '5'} sm={source !== 'quickreply' ? '5' : '4'} xs={'12'} className={cx('',{'variable-group' : isMobile()})} >
                                                {this.props.useForm !== undefined ?
                                                    this.getHookFormVariableContent(selectId, fieldsOptions)
                                                    : this.getVariableContent(selectId, fieldsOptions)
                                                }
                                            </Col>
                                             <Col md={source !== 'quickreply' ? '4' : '5'} sm={source !== 'quickreply' ? '4' : '5'} xs={'12'} className={cx('',{'variable-group' : isMobile()})}>
                                                <div className={'fallback-input-container'}>
                                                    <input
                                                        type={'text'}
                                                        className={cx('form-control', {
                                                            'mr-1': source !== 'quickreply'
                                                        })}
                                                        style={{ textOverflow: 'ellipsis', overflow: 'hidden', minWidth: 0 }}
                                                        autoComplete={'off'}
                                                        id={defaultValueID}
                                                        name={defaultValueID}
                                                        value={
                                                            this.props.values[selectId + "_selected"] !== undefined &&
                                                                this.props.values[selectId + "_selected"].value !== undefined &&
                                                                this.props.values[selectId + "_selected"].value === 'fallback' ? values[defaultValueID] : ""}
                                                        onChange={(e) => { this.props.handleInputChange(e) }}
                                                        placeholder={'Fallback Value'}
                                                        required={
                                                            this.props.values[selectId + "_selected"] !== undefined &&
                                                                this.props.values[selectId + "_selected"].value !== undefined &&
                                                                this.props.values[selectId + "_selected"].value === 'fallback' ? true : false
                                                        }
                                                        disabled={
                                                            this.props.values[selectId + "_selected"] !== undefined &&
                                                                this.props.values[selectId + "_selected"].value !== undefined &&
                                                                this.props.values[selectId + "_selected"].value === 'fallback' ? false : true
                                                        }
                                                    />
                                                    {source !== 'quickreply' && <CratioTooltip title={"In case the dynamic value is empty for a particular customer, the fallback value will instead be sent."} content={<FontAwesomeIcon icon={faCircleInfo} />} />}
                                                </div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Row>
                            )
                        })
                    }
                </div>
            </div>
        )
    }
}